(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.wbdCarouselViaCt = {
    attach: function (context, settings) {
      const selector = '.carousel--content > .wbdc--carousel-slider > .views__wrapper-list > .views__data > .views__data-rows';

      $(once('wbdCarouselViaCt', selector, context)).each(function () {
        const $slider = $(this);

        let isSlickInitialized = false;

        function updateSlick() {
          if (window.innerWidth > 1023) {
            if (!isSlickInitialized) {
              $slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                speed: 1000
              });
              isSlickInitialized = true;
            }
          } else {
            if (isSlickInitialized) {
              $slider.slick('unslick');
              isSlickInitialized = false;
            }
          }
        }

        updateSlick();

        $(window).on('resize.wbdCarousel', function () {
          updateSlick();
        });

      });
    }
  };
})(jQuery, Drupal, once);
